import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";

// Pages
import Index from "@/pages/Index";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ElfLetterGeneratorPage from "@/pages/ElfLetterGenerator";
import ElfNameGeneratorPage from "@/pages/ElfNameGenerator";
import NotFound from "@/pages/NotFound";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ElfEmergencyGuide from "@/pages/ElfEmergencyGuide";
import ElfHelp from "@/pages/ElfHelp";

// Admin Pages
import Login from "@/pages/Admin/Login";
import Dashboard from "@/pages/Admin/Dashboard";
import BlogManagement from "@/pages/Admin/BlogManagement";
import NewPost from "@/pages/Admin/NewPost";
import EditPost from "@/pages/Admin/EditPost";
import ToolsManagement from "@/pages/Admin/ToolsManagement";
import ImageRepository from "@/pages/Admin/ImageRepository";
import RootFileManager from "@/pages/Admin/RootFileManager";
import ElfNameGeneratorConfig from "@/pages/Admin/ElfNameGeneratorConfig";
import CraftGeneratorConfig from "@/pages/Admin/CraftGeneratorConfig";
import RecipeGeneratorConfig from "@/pages/Admin/RecipeGeneratorConfig";
import SceneGeneratorConfig from "@/pages/Admin/SceneGeneratorConfig";
import SceneIdeasImporter from "@/pages/Admin/SceneIdeasImporter";
import NewRecipe from "@/pages/Admin/NewRecipe";
import RedirectsManager from "@/pages/Admin/RedirectsManager";
import TestRedirects from "@/pages/TestRedirects";

// Layouts
import Layout from "@/components/Layout";

// Hooks for URL redirection
import { useRedirectMiddleware } from "@/hooks/useRedirectMiddleware";
import { RedirectPreloader } from "@/components/RedirectPreloader";
import { ServiceWorkerRegistration } from "@/components/ServiceWorkerRegistration";

const RedirectMiddleware: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useRedirectMiddleware();
  return <>{children}</>;
};

export default function AppRoutes() {
  return (
    <>
      <ServiceWorkerRegistration />
      <RedirectPreloader />
      <RedirectMiddleware>
        <Routes>
          <Route path="/" element={<Layout><Index /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/elf-help" element={<Layout><ElfHelp /></Layout>} />
          <Route path="/elf-help/:slug" element={<Layout><ElfEmergencyGuide /></Layout>} />
          <Route path="/elf-letter-generator" element={<Layout><ElfLetterGeneratorPage /></Layout>} />
          <Route path="/elf-name-generator" element={<Layout><ElfNameGeneratorPage /></Layout>} />
          <Route path="/terms" element={<Layout><Terms /></Layout>} />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/blog" element={<BlogManagement />} />
          <Route path="/admin/new-post" element={<NewPost />} />
          <Route path="/admin/edit-post/:id" element={<EditPost />} />
          <Route path="/admin/tools" element={<ToolsManagement />} />
          <Route path="/admin/image-repository" element={<ImageRepository />} />
          <Route path="/admin/root-file-manager" element={<RootFileManager />} />
          <Route path="/admin/elf-name-generator" element={<ElfNameGeneratorConfig />} />
          <Route path="/admin/craft-generator" element={<CraftGeneratorConfig />} />
          <Route path="/admin/recipe-generator" element={<RecipeGeneratorConfig />} />
          <Route path="/admin/scene-generator" element={<SceneGeneratorConfig />} />
          <Route path="/admin/scene-ideas-importer" element={<SceneIdeasImporter />} />
          <Route path="/admin/new-recipe" element={<NewRecipe />} />
          <Route path="/admin/redirects" element={<RedirectsManager />} />
          <Route path="/admin/test-redirects" element={<TestRedirects />} />

          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </RedirectMiddleware>
      <Toaster />
    </>
  );
}
